import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Welcome from "./features/onboarding/Welcome";
import HowItWorks from "./features/onboarding/HowItWorks";
import Goal from "./features/onboarding/Goal";
import { Intro } from "./features/level-test/Intro";
import { Test } from "./features/level-test/Test";
import { Result } from "./features/level-test/Result";
import { Today } from "./features/today/Today";
import Login from "./features/auth/Login";
import { AppStoreProvider } from "./state/AppStore";
import { AuthProvider } from "./auth/AuthContext";
import { CloudSync } from "./sync/CloudSync";
import { WORDS } from "./data/words";
import ResetPassword from "./features/auth/ResetPassword";
import UpdatePassword from "./features/auth/UpdatePassword";
import { RequireAccount } from "./auth/RequireAccount";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { useParams } from "react-router-dom";

// 次要路由延遲載入，縮小首頁初始 bundle
const Wordbook = lazy(() => import("./features/wordbook/Wordbook").then((m) => ({ default: m.Wordbook })));
const Stats = lazy(() => import("./features/stats/Stats").then((m) => ({ default: m.Stats })));
const Settings = lazy(() => import("./features/settings/Settings").then((m) => ({ default: m.Settings })));
const AccountSecurity = lazy(() => import("./features/settings/AccountSecurity").then((m) => ({ default: m.AccountSecurity })));
const QuizRunner = lazy(() => import("./features/quiz/QuizRunner").then((m) => ({ default: m.QuizRunner })));
const WordDetail = lazy(() => import("./features/word/WordDetail").then((m) => ({ default: m.WordDetail })));
const NewDeck = lazy(() => import("./features/deck/NewDeck").then((m) => ({ default: m.NewDeck })));
const DeckDetail = lazy(() => import("./features/deck/DeckDetail").then((m) => ({ default: m.DeckDetail })));
const Mistakes = lazy(() => import("./features/mistakes/Mistakes").then((m) => ({ default: m.Mistakes })));
const Import = lazy(() => import("./features/import/Import").then((m) => ({ default: m.Import })));

/** 全路由共用的 Suspense 邊界：固定全螢幕高度，避免載入時畫面跳動 */
function RouteFallback() {
  return (
    <div className="min-h-dvh flex items-center justify-center" aria-busy="true">
      <div className="font-grotesk text-[13px] tracking-[.14em] text-ink4">LOADING…</div>
    </div>
  );
}

function WordDetailWrapper() {
  const params = useParams();
  return <WordDetail id={params.id!} />;
}
function DeckDetailWrapper() {
  const params = useParams();
  return <DeckDetail key={params.id} />;
}
export default function App() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <div className="w-full min-h-screen">
        <ErrorBoundary>
          <AuthProvider>
          <AppStoreProvider>
            <CloudSync />
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Welcome />} />
                <Route path="/login" element={<Login />} />
                <Route path="/account/reset-password" element={<ResetPassword />} />
                <Route path="/account/update-password" element={<UpdatePassword />} />
                <Route path="/onboarding/how/:step" element={<HowItWorks />} />
                <Route path="/onboarding/goal" element={<Goal />} />
                <Route path="/level-test/intro" element={<Intro />} />
                <Route path="/level-test" element={<Test pool={WORDS} />} />
                <Route path="/level-test/result" element={<Result />} />
                <Route path="/today" element={<Today />} />
                <Route path="/deck/new" element={<NewDeck />} />
                <Route path="/deck/:id" element={<DeckDetailWrapper />} />
                <Route path="/mistakes" element={<Mistakes />} />
                <Route path="/import" element={<RequireAccount><Import /></RequireAccount>} />
                <Route path="/quiz/review" element={<QuizRunner mode="review" />} />
                <Route path="/quiz/new" element={<QuizRunner mode="new" />} />
                <Route path="/quiz/mistakes" element={<QuizRunner mode="mistakes" />} />
                <Route path="/wordbook" element={<Wordbook />} />
                <Route path="/stats" element={<Stats />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/settings/security" element={<AccountSecurity />} />
                <Route path="/word/:id" element={<WordDetailWrapper />} />
              </Routes>
            </Suspense>
          </AppStoreProvider>
        </AuthProvider>
        </ErrorBoundary>
      </div>
    </div>);
}
